import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

// Names must match the PHP serializer attributes exactly (CLAUDE.md 7.6).
export default function extendUser() {
  User.prototype.pregnancyStatus = Model.attribute('pregnancyStatus');
  User.prototype.pregnancyWeek = Model.attribute('pregnancyWeek');
  User.prototype.pregnancyCanView = Model.attribute('pregnancyCanView');
  User.prototype.pregnancyShowOnProfile = Model.attribute('pregnancyShowOnProfile');
  User.prototype.pregnancyShowOnPosts = Model.attribute('pregnancyShowOnPosts');

  // Owner-only mirrors of the stored preferences, used by the settings page.
  User.prototype.pregnancyShowOnProfilePref = Model.attribute('pregnancyShowOnProfilePref');
  User.prototype.pregnancyShowOnPostsPref = Model.attribute('pregnancyShowOnPostsPref');
}
